import React, { Ref, forwardRef } from 'react';
import classnames from 'classnames';
import { ButtonTypes, ButtonProps } from '../button/button';
import { Button } from '../button';
import { AirtameVariants, useVariantContext } from './variant-context-provider';

export type DialogConfirmButtonProps = Omit<ButtonProps, 'buttonType'>;

type ConfirmButtonTypes = keyof Omit<ButtonTypes, 'secondary'>;
const getButtonType = (variant: AirtameVariants): ConfirmButtonTypes => {
  switch (variant) {
    case 'error':
      return 'danger';
    case 'informative':
    default:
      return 'primary';
  }
};

export const DialogConfirmButton = forwardRef(
  (
    { className, ...props }: DialogConfirmButtonProps,
    ref: Ref<HTMLButtonElement>
  ): React.ReactElement => {
    const classNames = classnames(className, 'airtame-dialog__footer-confirm-button');

    const { variant } = useVariantContext();
    const buttonType: ConfirmButtonTypes = getButtonType(variant);

    return <Button ref={ref} buttonType={buttonType} {...props} className={classNames} />;
  }
);
DialogConfirmButton.displayName = 'DialogConfirmButton';
